import { getR2PublicPath } from '@bridebook/toolbox/src/api/r2/config';

/** Client-safe theme-CSS URL helpers (no node/S3 deps) — shared by css-store (server) and the guest <link>. */
const THEME_CSS_DIR = 'wedding-websites/motif/themes';

export const themeCssKey = (cssHash: string): string => `${THEME_CSS_DIR}/${cssHash}.css`;

/** Public CDN URL for a theme (guest page reads this; the editor reads the bucket-backed hash route). */
export const themeCssPublicUrl = (cssHash: string): string =>
  `${getR2PublicPath('media')}/${themeCssKey(cssHash)}`;
